export default __webpack_public_path__ + "static/media/market.12ee9650.png";